<template>
  <div class="flex flex-col mb-4 py-2 mt-4">
    <span class="text-xs"> Active Filters </span>
    <div
      class="flex lg:justify-between items-center pb-4 pt-3 px-4 w-full border-b border-truegray-300 flex-wrap lg:flex-no-wrap"
    >
      <div class="flex flex-col gap-2">
        <div
          v-if="filterFormKeywords"
          class="flex flex-row flex-wrap justify-start items-center gap-1"
        >
          <span class="mr-4 text-xs text-truegray-700 font-bold">Search</span>
          <span class="text-xs">
            {{ filterFormKeywords }}
          </span>
        </div>

        <div
          v-if="filterFormSelectedYear || !isEmpty(filterFormDateRange)"
          class="flex flex-row flex-wrap justify-start items-center gap-1"
        >
          <div class="mr-4 text-xs text-truegray-700 font-bold">Dates</div>
          <template v-if="filterFormSelectedYear">
            <span class="text-xs">
              Selected Year: {{ filterFormSelectedYear }}
            </span>
          </template>
          <div v-else class="flex flex-row items-center">
            <div
              v-for="(option, key) in filterFormDateRange"
              :key="key"
              class="mr-3"
              :class="{ 'border-l border-truegray-300 pl-3': key === 'dateTo' }"
            >
              <span class="text-xs">
                {{ option.data.text }}
              </span>
            </div>
          </div>
        </div>

        <div
          v-if="!isEmpty(selectedFiltersTagsOnly)"
          class="flex flex-row flex-wrap justify-start items-center gap-1"
        >
          <div class="mr-4 text-xs text-truegray-700 font-bold">Tags</div>
          <div
            v-for="(option, key) in selectedFiltersTagsOnly"
            :key="key"
            data-list="selectList"
          >
            <button
              type="button"
              class="rounded-full w-auto text-sm relative outline-none focus:outline-none border-0 flex flex-grow-0 justify-start items-stretch text-gray-500"
              @click="() => removeFilter(option)"
            >
              <span
                class="text-white py-1 px-2 text-xs bg-primary rounded-l-full"
                >{{ option.data.text }}</span
              >
              <div
                :style="{ marginLeft: '1px' }"
                class="text-white flex items-center justify-center rounded-r-full px-1 bg-primary"
              >
                <svg
                  :style="{ right: '1px' }"
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-3 w-3 relative"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </div>
            </button>
          </div>
        </div>
      </div>

      <div class="flex flex-row p-2 items-center justify-center mt-4 lg:mt-0">
        <p
          class="text-red-500 cursor-pointer whitespace-nowrap"
          @click="clearFilters"
        >
          Clear Filters
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, nextTick } from 'vue'
import { useStore } from '../../../../js/store/index.js'

export default defineComponent({
  name: 'FilterFormActiveFilters',
  emits: ['on-submit'],

  setup(_, { emit }) {
    const store = useStore()

    const filterFormKeywords = computed(
      () => store.getters['connections/getFilterFormKeywords'],
    )
    const filterFormSelectedYear = computed(
      () => store.getters['connections/getFilterFormSelectedYear'],
    )
    const filterFormDateRange = computed(
      () => store.getters['connections/getFilterFormDateRange'],
    )

    const selectedFiltersTagsOnly = computed(() =>
      store.getters['connections/getSelectedFiltersWithBlacklist'](),
    )

    const isEmpty = (obj) => {
      return Object.keys(obj).length === 0
    }

    const removeFilter = async (opt) => {
      store.dispatch('connections/dispatchRemoveFilter', opt)
      await nextTick()
      emit('on-submit')
    }

    const clearFilters = async () => {
      store.dispatch('connections/dispatchClearFilters')
      await nextTick()
      emit('on-submit')
    }

    return {
      filterFormKeywords,
      filterFormSelectedYear,
      filterFormDateRange,
      selectedFiltersTagsOnly,
      isEmpty,
      removeFilter,
      clearFilters,
    }
  },
})
</script>
